<template>
  <div>
    <!-- 自测题目的显示界面 -->
    <div class="page" v-if="windowShow == true">
      <!-- 左侧题型区域 -->
      <div class="left">
        <div
          class="item"
          :class="{ active: isActive == 'SingX' }"
          @click="switchItem('SingX')"
          v-if="SingXList.length > 0"
        >
          <img
            v-if="subjectType === 'SingX'"
            src="../../assets/img/icon_shu.png"
          />
          <img v-else src="../../assets/img/icon_shu_2.png" />
          <div>单选题</div>
        </div>
        <div
          class="item"
          :class="{ active: isActive == 'MultX' }"
          @click="switchItem('MultX')"
          v-if="MultXList.length > 0"
        >
          <img
            v-if="subjectType === 'MultX'"
            src="../../assets/img/icon_shu.png"
          />
          <img v-else src="../../assets/img/icon_shu_2.png" />
          <div>多选题</div>
        </div>
        <div
          class="item"
          :class="{ active: isActive == 'JudgX' }"
          @click="switchItem('JudgX')"
          v-if="JudgXList.length > 0"
        >
          <img
            v-if="subjectType === 'JudgX'"
            src="../../assets/img/icon_shu.png"
          />
          <img v-else src="../../assets/img/icon_shu_2.png" />
          <div>判断题</div>
        </div>
        <div
          class="item"
          :class="{ active: isActive == 'FillX' }"
          @click="switchItem('FillX')"
          v-if="FillXList.length > 0"
        >
          <img
            v-if="subjectType === 'FillX'"
            src="../../assets/img/icon_shu.png"
          />
          <img v-else src="../../assets/img/icon_shu_2.png" />
          <div>填空题</div>
        </div>
        <div
          class="item"
          :class="{ active: isActive == 'ProofX' }"
          @click="switchItem('ProofX')"
          v-if="ProofXList.length > 0"
        >
          <img
            v-if="subjectType === 'ProofX'"
            src="../../assets/img/icon_shu.png"
          />
          <img v-else src="../../assets/img/icon_shu_2.png" />
          <div>证明题</div>
        </div>
        <div
          class="item"
          :class="{ active: isActive == 'AnwsX' }"
          @click="switchItem('AnwsX')"
          v-if="AnwsXList.length > 0"
        >
          <img
            v-if="subjectType === 'AnwsX'"
            src="../../assets/img/icon_shu.png"
          />
          <img v-else src="../../assets/img/icon_shu_2.png" />
          <div>计算题</div>
        </div>
        <!-- 左侧按钮 -->
        <div class="btnBox" v-if="windowShow === true && examtype == undefined">
          <el-button type="primary" @click="secedeFunc" :loading="submitLoading"
            >退出测试</el-button
          >
          <el-button
            style="margin-left: 0"
            type="primary"
            @click="submitFunc"
            :loading="submitLoading"
            >交卷</el-button
          >
        </div>
        <div class="btnBox" v-if="windowShow === true && examtype == 'work'">
          <el-button type="primary" @click="secedeFunc" :loading="submitLoading"
            >退出</el-button
          >
          <el-button
            style="margin-left: 0"
            type="primary"
            @click="submitFunc"
            :loading="submitLoading"
            >提交</el-button
          >
        </div>
      </div>
      <!-- 中间题目切换区域 -->
      <div class="center" :style="{ height: contentHeight + 'px' }">
        <div v-if="subjectType === 'SingX'">
          <div
            v-for="(item, index) in SingXList"
            :key="item.id + new Date()"
            @click="singxIndexChange(index)"
            class="wrap"
          >
            <span
              class="item"
              :class="{ blue: SingXList[index].fill.length !== 0 }"
              :x-id="item.knowledgeID + item.qID"
              >单选题{{ index + 1 }}
              <!--            [{{item.knowledgeID+item.qID}}]-->
            </span>
            <img
              class="selected"
              v-show="index === subjectIndex"
              src="../../assets/img/icon_fanhui.png"
            />
          </div>
        </div>
        <div v-if="subjectType === 'MultX'">
          <div
            v-for="(item, index) in MultXList"
            :key="item.id + new Date()"
            @click="multxIndexChange(index)"
            class="wrap"
          >
            <span
              class="item"
              :class="{ blue: MultXList[index].correctOrder.length !== 0 }"
              :x-id="item.knowledgeID + item.qID"
              >多选题{{ index + 1 }}
            </span>
            <img
              class="selected"
              v-show="index === subjectIndex"
              src="../../assets/img/icon_fanhui.png"
            />
          </div>
        </div>
        <div v-if="subjectType === 'JudgX'">
          <div
            v-for="(item, index) in JudgXList"
            :key="item.id + new Date()"
            @click="judgexIndexChange(index)"
            class="wrap"
          >
            <span
              class="item"
              :class="{ blue: JudgXList[index].order !== undefined }"
              :x-id="item.knowledgeID + item.qID"
              >判断题{{ index + 1 }}</span
            >
            <img
              class="selected"
              v-show="index === subjectIndex"
              src="../../assets/img/icon_fanhui.png"
            />
          </div>
        </div>
        <div v-if="subjectType === 'FillX'">
          <div
            v-for="(item, index) in FillXList"
            :key="item.id + new Date()"
            @click="fillxChange(index)"
            class="wrap"
          >
            <span class="item" :x-id="item.knowledgeID + item.qID"
              >填空题{{ index + 1 }}</span
            >
            <img
              class="selected"
              v-show="index === subjectIndex"
              src="../../assets/img/icon_fanhui.png"
            />
          </div>
        </div>
        <div v-if="subjectType === 'ProofX'">
          <div
            v-for="(item, index) in ProofXList"
            :key="item.id + new Date()"
            @click="proofxChange(index)"
            class="wrap"
          >
            <span class="item" :x-id="item.knowledgeID + item.qID"
              >证明题{{ index + 1 }}</span
            >
            <img
              class="selected"
              v-show="index === subjectIndex"
              src="../../assets/img/icon_fanhui.png"
            />
          </div>
        </div>
        <div v-if="subjectType === 'AnwsX'">
          <div
            v-for="(item, index) in AnwsXList"
            :key="item.id + new Date()"
            @click="anwsxChange(index)"
            class="wrap"
          >
            <span class="item" :x-id="item.knowledgeID + item.qID"
              >计算题{{ index + 1 }}</span
            >
            <img
              class="selected"
              v-show="index === subjectIndex"
              src="../../assets/img/icon_fanhui.png"
            />
          </div>
        </div>
      </div>
      <!-- 右侧题目区域 -->
      <div class="right">
        <div class="item">
          <div
            class="title"
            v-if="subjectType === 'SingX' && SingXList.length > 0"
          >
            <!-- 题目信息区域 -->
            <!-- 单选 -->
            <div
              v-for="(item, index) in currentQuestion.steam"
              :key="index + new Date()"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j + new Date()">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <!-- 答题选择区域 -->
          <div
            class="groupbox"
            v-if="subjectType === 'SingX' && SingXList.length > 0"
          >
            <!-- 单选按钮改成了方块，不是圆形 -->
            <el-radio-group
              v-model="currentQuestion.fill"
              class="el_radio_group"
              @change="radioChange($event)"
            >
              <div
                v-for="(item, index) in currentQuestion.options"
                :key="index + new Date()"
                :data-index="item.index"
                @click="anwser(item, currentQuestion)"
              >
                <el-radio
                  :label="orderList[index].label"
                  class="el_radio"
                  :data-index="currentQuestion.orders[index]"
                >
                  <span
                    class="labelbox"
                    :data-index="currentQuestion.orders[index]"
                    >{{ orderList[index].label }}.{{ str }}</span
                  >
                  <span
                    v-for="(t, i) in item.ranginfos"
                    :key="i + new Date()"
                    :data-index="currentQuestion.orders[index]"
                  >
                    <span v-for="(it, j) in t.wordInfos" :key="j + new Date()">
                      <span v-if="it.wdType === 1" v-katex
                        >${{ it.latex }}$</span
                      >
                      <img v-else-if="it.wdType === 2" :src="it.buffer" />
                      <span v-else>{{ it.content }}</span>
                    </span>
                  </span>
                  <span v-if="item.correct === true && anwserShow == true">
                    <img src="../../assets/img/dui.png" alt="" />
                    正确的答案</span
                  >
                </el-radio>
                <br />
              </div>
            </el-radio-group>
          </div>
          <!-- 多选 -->
          <div
            class="title"
            v-if="subjectType === 'MultX' && MultXList.length > 0"
          >
            <!-- 题目信息区域 -->
            <div
              v-for="(item, index) in currentQuestion.steam"
              :key="index + new Date()"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j + new Date()">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <div class="groupcheckbox" v-if="subjectType === 'MultX'">
            <el-checkbox-group
              v-model="currentQuestion.correctOrder"
              class="el_radio_group"
              @change="
                MultXListChange(currentQuestion, currentQuestion.options)
              "
            >
              <div
                v-for="(item, index) in currentQuestion.options"
                :key="index + new Date()"
              >
                <el-checkbox
                  :label="item.index"
                  class="el_radio"
                  :key="index + new Date()"
                >
                  <span class="labelbox"
                    >{{ orderList[index].label }}.{{ str }}</span
                  >
                  <span v-for="(t, i) in item.ranginfos" :key="i + new Date()">
                    <span v-for="(it, j) in t.wordInfos" :key="j + new Date()">
                      <span v-if="it.wdType === 1" v-katex
                        >${{ it.latex }}$</span
                      >
                      <img v-else-if="it.wdType === 2" :src="it.buffer" />
                      <span v-else>{{ it.content }}</span>
                    </span>
                  </span>
                  <span v-if="item.correct === true && anwserShow == true">
                    <img src="../../assets/img/dui.png" alt="" />
                    正确的答案</span
                  >
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
          <!-- 判断 -->
          <div class="title" v-if="subjectType === 'JudgX'">
            <div
              v-for="(item, index) in currentQuestion.steam"
              :key="index + new Date()"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <div v-if="subjectType === 'JudgX'">
            <el-radio-group
              v-model="currentQuestion.order"
              class="el_radio_group"
              @change="judgxListChange(currentQuestion)"
            >
              <el-radio :label="1" class="el_radio">
                <!-- 正确和错误改成了图标 -->
                <span class="box"><i class="el-icon-circle-check"></i></span>
              </el-radio>
              <br />
              <el-radio :label="0" class="el_radio">
                <span class="box"><i class="el-icon-circle-close"></i></span>
              </el-radio>
            </el-radio-group>
          </div>
          <!-- 填空 -->
          <div class="title" v-if="subjectType === 'FillX'">
            <div
              v-for="(item, index) in currentQuestion.steam"
              :key="index + new Date()"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j + new Date()">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <!-- 证明 -->
          <div class="title" v-if="subjectType === 'ProofX'">
            <div
              v-for="(item, index) in currentQuestion.steam"
              :key="index + new Date()"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j + new Date()">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <!-- 计算 -->
          <div class="title" v-if="subjectType === 'AnwsX'">
            <div
              v-for="(item, index) in currentQuestion.steam"
              :key="index + new Date()"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j + new Date()">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
        </div>
        <!-- 底部题目切换区域 -->
        <div class="bottom">
          <el-button class="last" @click="last" type="primary"
            >上一题</el-button
          >
          <div>|</div>
          <el-button class="next" @click="next" type="primary"
            >下一题</el-button
          >
        </div>
      </div>
    </div>
    <!-- 查询答案 -->
    <div class="page" v-else>
      <!-- 左侧题型区域 -->
      <div class="left">
        <div
          class="item"
          :class="{ active: isActive == 'SingX' }"
          @click="switchItem('SingX')"
          v-if="SingXList.length > 0"
        >
          <img
            v-if="subjectType === 'SingX'"
            src="../../assets/img/icon_shu.png"
          />
          <img v-else src="../../assets/img/icon_shu_2.png" />
          <div>单选题</div>
        </div>
        <div
          class="item"
          :class="{ active: isActive == 'MultX' }"
          @click="switchItem('MultX')"
          v-if="MultXList.length > 0"
        >
          <img
            v-if="subjectType === 'MultX'"
            src="../../assets/img/icon_shu.png"
          />
          <img v-else src="../../assets/img/icon_shu_2.png" />
          <div>多选题</div>
        </div>
        <div
          class="item"
          :class="{ active: isActive == 'JudgX' }"
          @click="switchItem('JudgX')"
          v-if="JudgXList.length > 0"
        >
          <img
            v-if="subjectType === 'JudgX'"
            src="../../assets/img/icon_shu.png"
          />
          <img v-else src="../../assets/img/icon_shu_2.png" />
          <div>判断题</div>
        </div>
        <div
          class="item"
          :class="{ active: isActive == 'FillX' }"
          @click="switchItem('FillX')"
          v-if="FillXList.length > 0"
        >
          <img
            v-if="subjectType === 'FillX'"
            src="../../assets/img/icon_shu.png"
          />
          <img v-else src="../../assets/img/icon_shu_2.png" />
          <div>填空题</div>
        </div>
        <div
          class="item"
          :class="{ active: isActive == 'ProofX' }"
          @click="switchItem('ProofX')"
          v-if="ProofXList.length > 0"
        >
          <img
            v-if="subjectType === 'ProofX'"
            src="../../assets/img/icon_shu.png"
          />
          <img v-else src="../../assets/img/icon_shu_2.png" />
          <div>证明题</div>
        </div>
        <div
          class="item"
          :class="{ active: isActive == 'AnwsX' }"
          @click="switchItem('AnwsX')"
          v-if="AnwsXList.length > 0"
        >
          <img
            v-if="subjectType === 'AnwsX'"
            src="../../assets/img/icon_shu.png"
          />
          <img v-else src="../../assets/img/icon_shu_2.png" />
          <div>计算题</div>
        </div>
        <!-- 左侧按钮 -->
        <div class="btnBox">
          <el-button type="primary" @click="enterEvent">退出测试</el-button>
          <!-- <el-button
          style="margin-left:0;"
          type="primary"
          @click="submitFunc"
          :loading="submitLoading"
          >交卷</el-button
        > -->
        </div>
      </div>
      <!-- 中间题目切换区域 -->
      <div class="center" :style="{ height: contentHeight + 'px' }">
        <div v-if="subjectType === 'SingX'">
          <div
            v-for="(item, index) in SingXList"
            :key="item.id + new Date()"
            @click="singxIndexChange(index)"
            class="wrap"
          >
            <span
              class="item"
              :class="{ blue: SingXList[index].answer.length !== 0 }"
              :x-id="item.knowledgeID + item.qID"
              >单选题{{ index + 1 }}
              <!--            [{{item.knowledgeID+item.qID}}]-->
            </span>
            <img
              class="selected"
              v-show="index === subjectIndex"
              src="../../assets/img/icon_fanhui.png"
            />
          </div>
        </div>
        <div v-if="subjectType === 'MultX'">
          <div
            v-for="(item, index) in MultXList"
            :key="index"
            @click="multxIndexChange(index)"
            class="wrap"
          >
            <span
              class="item"
              :class="{ blue: MultXList[index].fill.length !== 0 }"
              :x-id="item.knowledgeID + item.qID"
              >多选题{{ index + 1 }}
            </span>
            <img
              class="selected"
              v-show="index === subjectIndex"
              src="../../assets/img/icon_fanhui.png"
            />
          </div>
        </div>
        <div v-if="subjectType === 'JudgX'">
          <div
            v-for="(item, index) in JudgXList"
            :key="index"
            @click="judgexIndexChange(index)"
            class="wrap"
          >
            <span
              class="item"
              :class="{ blue: JudgXList[index].answer !== undefined }"
              :x-id="item.knowledgeID + item.qID"
              >判断题{{ index + 1 }}</span
            >
            <img
              class="selected"
              v-show="index === subjectIndex"
              src="../../assets/img/icon_fanhui.png"
            />
          </div>
        </div>
        <div v-if="subjectType === 'FillX'">
          <div
            v-for="(item, index) in FillXList"
            :key="index"
            @click="fillxChange(index)"
            class="wrap"
          >
            <span class="item" :x-id="item.knowledgeID + item.qID"
              >填空题{{ index + 1 }}</span
            >
            <img
              class="selected"
              v-show="index === subjectIndex"
              src="../../assets/img/icon_fanhui.png"
            />
          </div>
        </div>
        <div v-if="subjectType === 'ProofX'">
          <div
            v-for="(item, index) in ProofXList"
            :key="index"
            @click="proofxChange(index)"
            class="wrap"
          >
            <span class="item" :x-id="item.knowledgeID + item.qID"
              >证明题{{ index + 1 }}</span
            >
            <img
              class="selected"
              v-show="index === subjectIndex"
              src="../../assets/img/icon_fanhui.png"
            />
          </div>
        </div>
        <div v-if="subjectType === 'AnwsX'">
          <div
            v-for="(item, index) in AnwsXList"
            :key="index"
            @click="anwsxChange(index)"
            class="wrap"
          >
            <span class="item" :x-id="item.knowledgeID + item.qID"
              >计算题{{ index + 1 }}</span
            >
            <img
              class="selected"
              v-show="index === subjectIndex"
              src="../../assets/img/icon_fanhui.png"
            />
          </div>
        </div>
      </div>
      <!-- 右侧题目区域 -->
      <div class="right">
        <!-- 题目内容主体 -->
        <div class="item">
          <div
            class="title"
            v-if="subjectType === 'SingX' && SingXList.length > 0"
          >
            <!-- 题目信息区域 -->
            <!-- 单选 -->
            <div v-for="(item, index) in currentQuestion.steam" :key="index">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
            <span>学生选择:{{ currentQuestion.answer }}</span>
          </div>
          <!-- 答案选择区域 -->
          <div
            class="groupbox"
            v-if="subjectType === 'SingX' && SingXList.length > 0"
          >
            <!-- 单选按钮改成了方块，不是圆形 -->

            <div
              v-for="(item, index) in currentQuestion.options"
              :key="item.id + index"
              :data-index="currentQuestion.order[index]"
            >
              <div>
                <span class="labelbox1"
                  >{{ orderList[index].label }}.{{ str }}</span
                >
                <span v-for="(t, i) in item.ranginfos" :key="i">
                  <span v-for="(it, j) in t.wordInfos" :key="j">
                    <span v-if="it.wdType === 1" v-katex>${{ it.latex }}$</span>
                    <img v-else-if="it.wdType === 2" :src="it.buffer" />
                    <span v-else>{{ it.content }}</span>
                  </span>
                </span>

                <span v-if="item.correct === true">
                  <img src="../../assets/img/dui.png" alt="" /> 正确的答案</span
                >
              </div>
              <br />
            </div>
            <p>【解析: 】</p>
            <div v-for="(item, index) in currentQuestion.solve" :key="index">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <!-- 多选 -->
          <div
            class="title"
            v-if="subjectType === 'MultX' && MultXList.length > 0"
          >
            <!-- 题目信息区域 -->
            <div v-for="(item, index) in currentQuestion.steam" :key="index">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
            <span>学生选择:{{ currentQuestion.fill }}</span>
          </div>
          <div class="groupcheckbox" v-if="subjectType === 'MultX'">
            <div
              v-for="(item, index) in currentQuestion.options"
              :key="item.id + index"
            >
              <div
                :label="orderList[index].label"
                class="el_radio"
                :key="index"
              >
                <span class="labelbox1"
                  >{{ orderList[index].label }}.{{ str }}</span
                >
                <span v-for="(t, i) in item.ranginfos" :key="i">
                  <span v-for="(it, j) in t.wordInfos" :key="j">
                    <span v-if="it.wdType === 1" v-katex>${{ it.latex }}$</span>
                    <img v-else-if="it.wdType === 2" :src="it.buffer" />
                    <span v-else>{{ it.content }}</span>
                  </span>
                </span>

                <span v-if="item.correct === true">
                  <img src="../../assets/img/dui.png" alt="" /> 正确的答案</span
                >
              </div>
            </div>
            <p>【解析: 】</p>
            <div v-for="(item, index) in currentQuestion.solve" :key="index">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <!-- 判断 -->
          <div
            class="title"
            v-if="subjectType === 'JudgX' && JudgXList.length > 0"
          >
            <div v-for="item in currentQuestion.steam" :key="item.id">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
            <span>学生选择:{{ currentQuestion.answer }}</span>
          </div>
          <div v-if="subjectType === 'JudgX'">
            <div>
              <!-- 正确和错误改成了图标 -->
              <span class="box"><i class="el-icon-circle-check"></i></span>
              <span v-if="currentQuestion.judge == 1">
                <img src="../../assets/img/dui.png" alt="" />正确的答案</span
              >
            </div>
            <br />
            <div>
              <span class="box"><i class="el-icon-circle-close"></i></span>
              <span v-if="currentQuestion.judge == 0">
                <img src="../../assets/img/dui.png" alt="" />正确的答案</span
              >
            </div>
            <p>【解析: 】</p>
            <div v-for="(item, index) in currentQuestion.solve" :key="index">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <!-- 填空 -->
          <div
            class="title"
            v-if="subjectType === 'FillX' && FillXList.length > 0"
          >
            <div v-for="(item, index) in currentQuestion.steam" :key="index">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
            <p>【解析: 】</p>
            <div v-for="item in currentQuestion.solve" :key="item.id">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <!-- 证明 -->
          <div
            class="title"
            v-if="subjectType === 'ProofX' && ProofXList.length > 0"
          >
            <div v-for="(item, index) in currentQuestion.steam" :key="index">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
            <p>【解析: 】</p>
            <div v-for="(item, index) in currentQuestion.solve" :key="index">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <!-- 计算 -->
          <div
            class="title"
            v-if="subjectType === 'AnwsX' && AnwsXList.length > 0"
          >
            <div v-for="(item, index) in currentQuestion.steam" :key="index">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
            <p>【解析: 】</p>
            <div v-for="(item, index) in currentQuestion.solve" :key="index">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
        </div>
        <!-- 底部题目切换区域 -->
        <div class="bottom">
          <el-button class="last" @click="last" type="primary"
            >上一题</el-button
          >
          <div>|</div>
          <el-button class="next" @click="next" type="primary"
            >下一题</el-button
          >
        </div>
      </div>
      <!-- 提示信息弹出层 -->
      <el-dialog
        title="提示信息"
        :visible.sync="centerDialogVisible"
        width="50%"
        :show-close="false"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        center
      >
        <div v-if="this.SingXList.length > 0" class="tipsBox">
          <span>单选题：{{ this.SingXList.length }}题</span
          ><span>正确：{{ this.correctChoose }}题</span
          ><span>正确率：{{ this.percent }}%</span>
        </div>
        <div v-if="this.MultXList.length > 0" class="tipsBox">
          <span>多选题：{{ this.MultXList.length }}题</span
          ><span>正确：{{ this.correctChoose1 }}题</span
          ><span>正确率：{{ this.percent1 }}%</span>
        </div>
        <div v-if="this.JudgXList.length > 0" class="tipsBox">
          <span>判断题：{{ this.JudgXList.length }}题</span
          ><span>正确：{{ this.correctChoose2 }}题</span
          ><span>正确率：{{ this.percent2 }}%</span>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="enterEvent()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { submitTeachingTask } from "@/api/student";
// import Steam from "@/util/steam.js";
import { convertToFullQuestion } from "@/util/extraction.js";
import _ from "lodash";
import { mapState } from "vuex";

export default {
  name: "test-detail",
  components: {},
  data() {
    //这里存放数据
    return {
      resultList: [],
      examtype: undefined,
      centerDialogVisible: false,
      str: "\u3000",
      isActive: "",
      list: [],
      id: "",
      //题库
      anwserShow: false,
      SingXList: [],
      MultXList: [],
      JudgXList: [],
      ProofXList: [],
      FillXList: [],
      AnwsXList: [],
      //当前题目
      currentQuestion: {},
      //题型(单选)
      subjectType: "",
      //题型下标
      subjectIndex: 0,
      windowShow: true,
      //选项
      orderList: [
        {
          value: 0,
          label: "A"
        },
        {
          value: 1,
          label: "B"
        },
        {
          value: 2,
          label: "C"
        },
        {
          value: 3,
          label: "D"
        },
        {
          value: 4,
          label: "E"
        },
        {
          value: 5,
          label: "F"
        },
        {
          value: 6,
          label: "G"
        },
        {
          value: 7,
          label: "H"
        },
        {
          value: 8,
          label: "I"
        }
      ],
      contentHeight: 0,
      submitLoading: false,
      examinationDiff: "",
      examinationSer: "",
      //多选
      multipleTemp: [],
      // answers题目
      params: [],
      choose: {
        A: 0,
        B: 1,
        C: 2,
        D: 3,
        E: 4,
        F: 5,
        G: 6,
        H: 7,
        I: 8
      },
      correctChoose: 0,
      correctChoose1: 0,
      correctChoose2: 0,
      percent: 0,
      percent1: 0,
      percent2: 0
      // correct: [] //客观题正确的数量
    };
  },
  //监听属性 类似于data概念
  computed: mapState({
    countdownTime: state => state.examination.countdownTime
  }),
  //监控data中的数据变化
  watch: {
    countdownTime(value) {
      if (value === 0) {
        this.$alert("考试时间已结束", "提示", {
          confirmButtonText: "确认",
          showClose: false,
          callback: () => {
            this.sunbmitAnswer();
          }
        });
      }
    }
  },
  //方法集合
  async mounted() {
    let _this = this;
    //在即将离开当前页面(刷新或关闭)时执行
    window.onbeforeunload = function() {
      return "quit?";
    };
    if (this.$route.query.show == 1) {
      _this.windowShow = true;
    } else {
      _this.windowShow = false;
    }
    this.examinationDiff = this.$route.query.examinationDiff;
    this.examinationSer = this.$route.query.examinationSer;
    //console.log(1);
    await this.getDetail(); //必须等待有结果了,才能继续调用下一个,否者拿不到数据
    this.contentHeight = document.body.clientHeight - 64;
    console.log(this.windowShow);
    if (_this.windowShow == true) {
      this.firstFunc();
    }
  },
  methods: {
    getTopicinfo() {
      this.windowShow = false;
      this.centerDialogVisible = false;
    },
    //answer(选项，题目)
    anwser(item, qestion) {
      this.resultList.forEach(val => {
        if (val.questionId === qestion.qid) {
          val.result = item.index;
        }
      });
      console.log(this.resultList.find(x => x.questionId === qestion.qid));
    },
    judgxListChange(item) {
      this.resultList.forEach(val => {
        if (val.questionId === item.qid) {
          val.result = item.order;
        }
      });
    },
    radioChange() {
      console.log(this.SingXList[this.subjectIndex]);
    },
    enterEvent() {
      this.centerDialogVisible = false;
      this.$router.push("/home");
    },
    //第一次调用,默认获取第一个题目的数据
    firstFunc() {
      if (this.SingXList.length > 0) {
        this.singxIndexChange(this.subjectIndex);
        this.subjectType = "SingX";
        return;
      }
      if (this.MultXList.length > 0) {
        this.multxIndexChange(this.subjectIndex);
        this.subjectType = "MultX";
        return;
      }
      if (this.JudgXList.length > 0) {
        this.judgexIndexChange(this.subjectIndex);
        this.subjectType = "JudgX";
        return;
      }
      this.updatesubject();
    },
    fillxChange(index) {
      this.subjectIndex = index;
      this.currentQuestion = {
        steam: [],
        options: [],
        solve: [],
        fill: []
      };
      this.$nextTick(() => {
        this.currentQuestion = this.FillXList[this.subjectIndex];
      });
    },
    proofxChange(index) {
      this.subjectIndex = index;
      this.currentQuestion = {
        steam: [],
        options: [],
        solve: []
      };
      this.$nextTick(() => {
        this.currentQuestion = this.ProofXList[this.subjectIndex];
      });
    },
    anwsxChange(index) {
      this.subjectIndex = index;

      this.currentQuestion = {
        steam: [],
        options: [],
        solve: []
      };
      this.$nextTick(() => {
        this.currentQuestion = this.AnwsXList[this.subjectIndex];
      });
      console.log(this.AnwsXList);
    },
    updatesubject() {
      this.SingXList.forEach(sigx => {
        let arr = sigx.options;
        //获取打乱顺序之后的index
        let arr1 = arr
          .map(item => {
            if (item.index) {
              return item.index;
            } else {
              return item.opsindex; //要通过索引来判断正确选项,有的选项是opsindex
            }
          })
          .map(item => {
            if (item === undefined) {
              return 0;
            }
            return item;
          });
        // console.log(arr1);
        let arr2 = arr1
          .map((item, index) => {
            if (item.correct || item.iscorrect) {
              return index;
            }
          }) //去掉undefind,如果为零,则是直接返回
          .filter(item => {
            if (item === 0) {
              return "0";
            }
            return item;
          });

        sigx.orders = arr1;
        sigx.correctorders = arr2;
      });
      this.MultXList.forEach(mulx => {
        let arr = mulx.options;
        //多选所有的index
        let arr1 = arr
          .map(item => {
            if (item.index) {
              return item.index;
            } else {
              return item.opsindex; //要通过索引来判断正确选项,有的选项是opsindex
            }
          })
          .map(item => {
            if (item === undefined) {
              return 0;
            }
            return item;
          });
        //正确答案的index
        let arr2 = arr
          .map((item, index) => {
            if (item.correct || item.iscorrect) {
              return index;
            }
          }) //去掉undefind,如果为零,则是直接返回
          .filter(item => {
            if (item === 0) {
              return "0";
            }
            return item;
          });

        mulx.orders = arr1;
        mulx.correctorders = arr2;
      });
      this.JudgXList.forEach(judx => {
        let str = judx.judge;
        //保存题目的正确答案
        if (str === "错误") {
          judx.correctorders = [0];
          judx.correctOrder = "0";
        }
        if (str === "正确") {
          judx.correctorders = [1];
          judx.correctOrder = "1";
        }
        judx.orders = ["1", "0"];
      });
    },
    //处理单选的选项
    singxIndexChange(index) {
      this.subjectIndex = index;
      let arr = this.SingXList[this.subjectIndex].options;
      //获取打乱顺序之后的index
      console.log("singxindexchanged", index);
      let arr1 = arr
        .map(item => {
          if (item.index) {
            return item.index;
          } else {
            return item.opsindex; //要通过索引来判断正确选项,有的选项是opsindex
          }
        })
        .map(item => {
          if (item === undefined) {
            return 0;
          }
          return item;
        });
      let arr2 = arr
        .map(item => {
          if (item.correct || item.iscorrect) {
            return item.index;
          }
        }) //去掉undefind,如果为零,则是直接返回
        .filter(item => {
          if (item === 0) {
            return "0";
          }
          return item;
        });

      this.SingXList[this.subjectIndex].orders = arr1;
      this.SingXList[this.subjectIndex].correctorders = arr2;
      this.currentQuestion = {
        steam: [],
        options: [],
        solve: []
      };
      console.log(this.SingXList[this.subjectIndex]);
      this.$nextTick(() => {
        this.currentQuestion = this.SingXList[this.subjectIndex];
      });
    },
    //判断数组是否相等
    equarArr(a, b) {
      // 判断数组的长度
      if (a.length !== b.length) {
        return false;
      } else {
        // 循环遍历数组的值进行比较
        for (let i = 0; i < a.length; i++) {
          if (a[i] !== b[i]) {
            return false;
          }
        }
        return true;
      }
    },
    //处理多选的选项
    multxIndexChange(index) {
      this.subjectIndex = index;
      let arr = this.MultXList[this.subjectIndex].options;
      this.MultXList[this.subjectIndex].options = [];
      let arrq = this.MultXList[this.subjectIndex].steam;
      this.MultXList[this.subjectIndex].steam = [];
      this.$nextTick(() => {
        this.MultXList[this.subjectIndex].options = arr;
        this.MultXList[this.subjectIndex].steam = arrq;
      });
      //多选所有的index
      let arr1 = arr
        .map(item => {
          if (item.index) {
            return item.index;
          } else {
            return item.opsindex; //要通过索引来判断正确选项,有的选项是opsindex
          }
        })
        .map(item => {
          if (item === undefined) {
            return 0;
          }
          return item;
        });
      //正确答案的index
      let arr2 = arr
        .map((item, index) => {
          if (item.correct || item.iscorrect) {
            return index;
          }
        }) //去掉undefind,如果为零,则是直接返回
        .filter(item => {
          if (item === 0) {
            return "0";
          }
          return item;
        });
      //console.log(arr1,arr2);
      this.MultXList[this.subjectIndex].orders = arr1;
      this.MultXList[this.subjectIndex].correctorders = arr2;

      this.currentQuestion = {
        steam: [],
        options: [],
        solve: []
      };
      this.$nextTick(() => {
        this.currentQuestion = this.MultXList[this.subjectIndex];
      });
    },
    //处理判断的数据
    judgexIndexChange(index) {
      this.subjectIndex = index;
      console.log(this.JudgXList[this.subjectIndex]);
      let arr = this.JudgXList[this.subjectIndex].steam;
      this.JudgXList[this.subjectIndex].steam = [];
      this.$nextTick(() => {
        this.JudgXList[this.subjectIndex].steam = arr;
      });
      let str = this.JudgXList[this.subjectIndex].judge;
      //保存题目的正确答案
      console.log(this.JudgXList);
      if (str === "错误") {
        this.JudgXList[this.subjectIndex].correctorders = "0";
      }
      if (this.JudgXList[this.subjectIndex].answer == 0) {
        this.JudgXList[this.subjectIndex].answer == "错误";
      }
      if (this.JudgXList[this.subjectIndex].answer == 1) {
        this.JudgXList[this.subjectIndex].answer == "正确";
      }
      if (str === "正确") {
        this.JudgXList[this.subjectIndex].correctorders = "1";
      }
      this.currentQuestion = {
        steam: [],
        options: [],
        solve: []
      };
      this.$nextTick(() => {
        this.currentQuestion = this.JudgXList[this.subjectIndex];
      });
    },
    //加载题目
    async getDetail() {
      let data = JSON.parse(localStorage.getItem("workquestion"));
      let list = [];

      data.map(val => {
        list.push(val.teachingTaskDetail);
        this.resultList.push(val.studentResult);
      });
      let arr = list.map(item => {
        return convertToFullQuestion(item);
      });
      this.filterArray(arr);

      //对选项进行乱序,并返回
    },
    filterArray(arr) {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let arr1 = [];
      arr.forEach(item => {
        arr1.push(item);
      });
      arr1.filter(item => {
        this.choose = [];
        //还原答案
        let result = this.resultList;
        result.forEach(s => {
          if (s.questionId == item.qid) {
            if (item.subjectType == "SingX" || item.subjectType == "MultX") {
              let orgoptions = item.options;
              item.options = [];
              for (let n = 0; n < s.answerSequences.length; n++) {
                let optid = s.answerSequences[n];
                orgoptions.forEach(optitem => {
                  if (optitem.index == optid) {
                    item.options.push(optitem);
                  }
                });
              }
              item.order = s.answerSequences;
              if (item.subjectType == "MultX") {
                item.answer = s.result.split(",");
              } else {
                item.answer = s.result;
              }
            }
            if (item.subjectType == "JudgX") {
              if (s.result === "0") {
                item.answer = "错误";
              } else if (s.result === "1") {
                item.answer = "正确";
              } else {
                item.answer = "";
              }
            }
          }
        });

        console.log(item);
        item.usr_choice = item.answer;
        if (item.subjectType == "SingX") {
          let pindex = parseInt(item.answer);
          item.options.forEach((opt, index) => {
            if (opt.index === pindex) {
              switch (index) {
                case 0:
                  item.answer = "A";
                  break;
                case 1:
                  item.answer = "B";
                  break;
                case 2:
                  item.answer = "C";
                  break;
                case 3:
                  item.answer = "D";
                  break;
                case 4:
                  item.answer = "E";
                  break;
                case 5:
                  item.answer = "F";
                  break;
                case 6:
                  item.answer = "G";
                  break;
                case 7:
                  item.answer = "H";
                  break;
                default:
                  break;
              }
            }
          });
        }
        if (item.subjectType == "MultX") {
          item.fill = "";
          item.answer.map(val => {
            let pindex = parseInt(val);
            item.options.forEach((opt, index) => {
              if (opt.index === pindex) {
                switch (index) {
                  case 0:
                    item.fill = item.fill.concat("A");
                    break;
                  case 1:
                    item.fill = item.fill.concat("B");
                    break;
                  case 2:
                    item.fill = item.fill.concat("C");
                    break;
                  case 3:
                    item.fill = item.fill.concat("D");
                    break;
                  case 4:
                    item.fill = item.fill.concat("E");
                    break;
                  case 5:
                    item.fill = item.fill.concat("F");
                    break;
                  case 6:
                    item.fill = item.fill.concat("G");
                    break;
                  case 7:
                    item.fill = item.fill.concat("H");
                    break;
                  default:
                    break;
                }
              }
            });
          });
        }
      });
      this.SingXList = arr1.filter(item => {
        return item.subjectType === "SingX";
      });
      this.MultXList = arr1.filter(item => {
        return item.subjectType === "MultX";
      });
      this.JudgXList = arr1.filter(item => {
        return item.subjectType === "JudgX";
      });
      this.ProofXList = arr1.filter(item => {
        return item.subjectType === "ProofX";
      });
      this.FillXList = arr1.filter(item => {
        return item.subjectType === "FillX";
      });
      this.AnwsXList = arr1.filter(item => {
        return item.subjectType === "AnwsX";
      });

      this.$nextTick(() => {
        this.setImageWidth();
      });
      if (this.windowShow == false) {
        let vcv = [];
        this.SingXList.map(item => {
          console.log(item.order);
          // item.order = JSON.parse(item.order);
          vcv.push(item);
          return item;
        });
        loading.close();
      } else {
        arr1 = arr.map(item => {
          return item;
        });
        this.SingXList = arr1.filter(item => {
          return item.subjectType === "SingX";
        });
        this.MultXList = arr1.filter(item => {
          return item.subjectType === "MultX";
        });
        this.JudgXList = arr1.filter(item => {
          return item.subjectType === "JudgX";
        });
        this.ProofXList = arr1.filter(item => {
          return item.subjectType === "ProofX";
        });
        this.FillXList = arr1.filter(item => {
          return item.subjectType === "FillX";
        });
        this.AnwsXList = arr1.filter(item => {
          return item.subjectType === "AnwsX";
        });
        this.$nextTick(() => {
          this.setImageWidth();
        });
        loading.close();
      }
    },
    //提交答案信息处理
    async submitAnswer() {
      this.SingXList = this.SingXList.map(item => {
        console.log(item);
        for (var i = 0; i < item.orders.length; i++) {
          this.choose[String.fromCharCode(65 + i)] = item.orders[i]; //输出A-Z 26个大写字母
        }
        if (item.fill.length) {
          item.answer = this.choose[item.fill];
        } else {
          item.answer = "";
        }
        item.order = item.orders.join(",");
        item.qid = item.serialnumber.slice(3, 6);
        item.knowledgeID = item.serialnumber.slice(0, 3);
        if (item.correctorders) {
          item.correctOrder = item.correctorders.join(",");
        }

        item.qtype = "SingX";
        item.answerList = this.choose;
        return item;
      });
      // console.log(this.SingXList);
      this.MultXList = this.MultXList.map(item => {
        for (var i = 0; i < item.orders.length; i++) {
          this.choose[String.fromCharCode(65 + i)] = item.orders[i]; //输出A-Z 26个大写字母
        }
        console.log("xxx->" + typeof item.fill);
        if (item.fill.length) {
          let chs = item.fill.toString().split(",");
          let fhs = [];
          chs.forEach(e => {
            fhs.push(this.choose[e]);
          });
          item.answer = fhs.join(",");
        } else {
          item.answer = "";
        }
        item.order = item.orders.join(",");
        item.qid = item.knowledgeID = item.serialnumber.slice(0, 3);
        item.qtype = "MultX";
        item.correctOrder = item.correctorders.join(",");
        item.answerList = this.choose;
        return item;
      });
      this.JudgXList = this.JudgXList.map(item => {
        if (item.order) {
          let temp = "";
          temp = item.order;
          item.answer = temp;
        } else {
          item.answer = "";
        }
        item.qid = item.serialnumber.slice(3, 6);
        item.qtype = "JudgX";
        item.knowledgeID = item.serialnumber.slice(0, 3);
        //item.correctOrder = item.correctorders;
        item.order = item.correctorders;
        item.sc;
        return item;
      });
      this.FillXList = this.FillXList.map(item => {
        console.log(item);
        if (item.order) {
          let temp = "";
          temp = item.order;
          item.answer = temp;
        } else {
          item.answer = "";
        }
        item.qid = item.serialnumber.slice(3, 6);
        item.qtype = "JudgX";
        item.knowledgeID = item.serialnumber.slice(0, 3);
        //item.correctOrder = item.correctorders;
        item.order = item.correctorders;
        item.sc;
        return item;
      });
      this.AnwsXList = this.AnwsXList.map(item => {
        if (item.order) {
          let temp = "";
          temp = item.order;
          item.answer = temp;
        } else {
          item.answer = "";
        }
        item.qid = item.serialnumber.slice(3, 6);
        item.qtype = "JudgX";
        item.knowledgeID = item.serialnumber.slice(0, 3);
        //item.correctOrder = item.correctorders;
        item.order = item.correctorders;
        item.sc;
        return item;
      });
      this.ProofXList = this.ProofXList.map(item => {
        if (item.order) {
          let temp = "";
          temp = item.order;
          item.answer = temp;
        } else {
          item.answer = "";
        }
        item.qid = item.serialnumber.slice(3, 6);
        item.qtype = "JudgX";
        item.knowledgeID = item.serialnumber.slice(0, 3);
        //item.correctOrder = item.correctorders;
        item.order = item.correctorders;
        item.sc;
        return item;
      });
      this.params = [
        ...this.SingXList,
        ...this.MultXList,
        ...this.JudgXList,
        ...this.FillXList,
        ...this.AnwsXList,
        ...this.ProofXList
      ];
      this.params = _.cloneDeep(this.params).map(item => {
        delete item.fill;
        delete item.hasfill;
        delete item.hasjudge;
        delete item.hasops;
        delete item.hassolve;
        delete item.answerbuffer;
        delete item.level;
        delete item.options;
        delete item.serialnumber;
        delete item.solve;
        delete item.solvebuffer;
        delete item.steam;
        delete item.steambuffer;
        delete item.judge;
        delete item.correctorders;
        delete item.orders;
        delete item.answers;
        return item;
      });
      // console.log("params", this.params);
      //拿到的数组,是处理好的题目的信息

      if (this.SingXList.length > 0) {
        //单选的正确率计算
        let arr = this.params

          .map(item => {
            if (item.qtype === "SingX") {
              item.order = item.order.split(",");
              this.choose = [];

              for (var i = 0; i < item.order.length; i++) {
                this.choose[String.fromCharCode(65 + i)] = item.order[i]; //输出A-Z 26个大写字母
              }
              //正确的题目
              return item.answer == item.correctOrder;
            }
          })
          .filter(item => {
            return item;
          });
        // this.correct.push(arr);
        this.correctChoose = arr.length;
        this.percent = ((arr.length / this.SingXList.length) * 100).toFixed(2);
      }
      if (this.MultXList.length > 0) {
        //多选的正确率计算
        let arr = this.params
          .map(item => {
            if (item.qtype === "MultX") {
              //选择的答案变成数组
              item.answer = [...item.answer];
              let arr1 = item.answer
                .map(i => {
                  return this.choose[i];
                })
                .filter(item => {
                  if (item === 0) {
                    return "0";
                  }
                  return item;
                });
              //排序
              arr1.sort((a, b) => {
                return a - b;
              });
              // console.log("arr1", arr1);
              //题目的正确答案变成数组
              item.correctOrder = item.correctOrder.split(",").map(item => {
                return +item; //数组的内容也要一致,转成数字
              });
              // console.log("item", item.correctOrder);
              return this.equarArr(arr1, item.correctOrder);
            }
          })
          .filter(item => {
            return item;
          });
        // console.log("true", arr);
        // this.correct.push(arr);
        this.correctChoose1 = arr.length;
        this.percent1 = ((arr.length / this.MultXList.length) * 100).toFixed(2);
      }
      if (this.JudgXList.length > 0) {
        //判断的正确率计算
        let arr = this.params
          .map(item => {
            if (item.qtype === "JudgX") {
              //正确的题目
              return item.answer == item.correctOrder;
            }
          })
          .filter(item => {
            return item;
          });
        // console.log("arr", arr);
        // this.correct.push(arr);
        this.correctChoose2 = arr.length;
        this.percent2 = ((arr.length / this.JudgXList.length) * 100).toFixed(2);
      }
      console.log(this.params);
      let objectiveAnswers = [];
      this.params.forEach(item => {
        console.log(item);
        let obj = {};
        obj.answer = item.answer;
        obj.mathTaskDetailId = item.id;
        objectiveAnswers.push(obj);
      });
      console.log(objectiveAnswers);

      window.onbeforeunload = null;
      this.$message({
        type: "success",
        message: "提交成功!"
      });
      console.log(this.JudgXList, this.SingXList, this.MultXList);
      this.SingXList.forEach(item => {
        let index;
        console.log(item.answer);
        index = item.orders.indexOf(item.answer);
        if (index == 0) {
          item.answer = "A";
        } else if (index == 1) {
          item.answer = "B";
        } else if (index == 2) {
          item.answer = "C";
        } else if (index == 3) {
          item.answer = "D";
        } else if (index == 4) {
          item.answer = "E";
        } else if (index == 5) {
          item.answer = "F";
        } else if (index == 6) {
          item.answer = "G";
        } else {
          item.answer = "";
        }
      });
      this.JudgXList.forEach(item => {
        if (item.judge == 0) {
          item.answer = "正确";
        } else if (item.judge == 1) {
          item.answer = "错误";
        }
      });
      this.MultXList.forEach(item => {
        console.log(item.answer);

        item.answer = [];
        item.fill.forEach(x => {
          item.answer = item.answer.concat(x);
        });
        console.log(item);
      });
      this.centerDialogVisible = true;

      this.submitLoading = false;
    },
    //提交
    submitFunc() {
      //提示信息
      let data = {
        picUrls: "",
        resultList: this.resultList,
        studentId: JSON.parse(localStorage.getItem("userInfo")).studentId,
        taskId: localStorage.getItem("taskId")
      };
      console.log(data);
      submitTeachingTask(data).then(res => {
        console.log(res);
      });
      this.$message({
        type: "message",
        message: "提交成功!"
      });
      this.$router.go(-1);
    },
    setImageWidth() {
      let subjectImg = [];
      let imgs = document.getElementsByTagName("img");
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].className == "subjectImage") {
          subjectImg.push(imgs[i]);
        }
      }
      subjectImg.forEach(item => {
        item.style.zoom = "50%";
      });
    },
    switchItem(type) {
      this.isActive = type;
      this.subjectType = type;
      this.subjectIndex = 0;
      this.currentQuestion = {
        steam: [],
        options: [],
        solve: [],
        fill: ""
      };
      if (type === "SingX") {
        this.$nextTick(() => {
          this.currentQuestion = this.SingXList[0];
        });
      }
      if (type === "MultX") {
        this.$nextTick(() => {
          this.currentQuestion = this.MultXList[0];
        });
      }
      if (type === "JudgX") {
        this.$nextTick(() => {
          this.currentQuestion = this.JudgXList[0];
        });
      }
      if (type === "FillX") {
        this.$nextTick(() => {
          this.currentQuestion = this.FillXList[0];
        });
      }
      if (type === "ProofX") {
        this.$nextTick(() => {
          this.currentQuestion = this.ProofXList[0];
        });
      }
      if (type === "AnwsX") {
        this.$nextTick(() => {
          this.currentQuestion = this.AnwsXList[0];
        });
      }
      if (this.subjectType === "MultX") {
        this.multipleTemp = this.MultXList[0].answers;
      }
    },
    //上一题
    last() {
      if (this.subjectIndex === 0) {
        return;
      }
      this.subjectIndex = this.subjectIndex - 1;
      if (this.subjectType === "SingX") {
        this.singxIndexChange(this.subjectIndex);
        // let arr = this.SingXList[this.subjectIndex].options;
        // this.SingXList[this.subjectIndex].options = [];
        // let arrq = this.SingXList[this.subjectIndex].steam;
        // this.SingXList[this.subjectIndex].steam = [];
        // let solv = this.SingXList[this.subjectIndex].solve;
        // this.SingXList[this.subjectIndex].solve = [];
        // this.$nextTick(() => {
        //   this.SingXList[this.subjectIndex].options = arr;
        //   this.SingXList[this.subjectIndex].steam = arrq;
        //   this.SingXList[this.subjectIndex].solve = solv;
        // });
      }
      if (this.subjectType === "MultX") {
        // let arr = this.MultXList[this.subjectIndex].options;
        // this.MultXList[this.subjectIndex].options = [];
        // let arrq = this.MultXList[this.subjectIndex].steam;
        // this.MultXList[this.subjectIndex].steam = [];
        // let solv = this.MultXList[this.subjectIndex].solve;
        // this.MultXList[this.subjectIndex].solve = [];
        // this.$nextTick(() => {
        //   this.MultXList[this.subjectIndex].options = arr;
        //   this.MultXList[this.subjectIndex].steam = arrq;
        //   this.MultXList[this.subjectIndex].solve = solv;
        // });
        this.multxIndexChange(this.subjectIndex);
        this.multipleTemp = this.MultXList[this.subjectIndex].answers;
      }
      if (this.subjectType === "JudgX") {
        this.judgexIndexChange(this.subjectIndex);
        // let arr = this.JudgXList[this.subjectIndex].steam;
        // this.JudgXList[this.subjectIndex].steam = [];
        // let solv = this.JudgXList[this.subjectIndex].solve;
        // this.JudgXList[this.subjectIndex].solve = [];
        // this.$nextTick(() => {
        //   this.JudgXList[this.subjectIndex].steam = arr;
        //   this.JudgXList[this.subjectIndex].solve = solv;
        // });
      }
      if (this.subjectType === "FillX") {
        this.fillxChange(this.subjectIndex);
      }
      if (this.subjectType === "ProofX") {
        this.proofxChange(this.subjectIndex);
      }
      if (this.subjectType === "AnwsX") {
        this.anwsxChange(this.subjectIndex);
      }
    },
    //下一题
    next() {
      if (
        this.subjectType === "SingX" &&
        this.subjectIndex < this.SingXList.length - 1
      ) {
        this.subjectIndex = this.subjectIndex + 1;
        // let arr = this.SingXList[this.subjectIndex].options;
        // this.SingXList[this.subjectIndex].options = [];
        // let arrq = this.SingXList[this.subjectIndex].steam;
        // this.SingXList[this.subjectIndex].steam = [];
        // this.$nextTick(() => {
        //   this.SingXList[this.subjectIndex].options = arr;
        //   this.SingXList[this.subjectIndex].steam = arrq;
        // });
        this.singxIndexChange(this.subjectIndex);
      } else if (
        this.subjectType === "MultX" &&
        this.subjectIndex < this.MultXList.length - 1
      ) {
        this.subjectIndex = this.subjectIndex + 1;
        // let arr = this.MultXList[this.subjectIndex].options;
        // this.MultXList[this.subjectIndex].options = [];
        // let arrq = this.MultXList[this.subjectIndex].steam;
        // this.MultXList[this.subjectIndex].steam = [];
        // this.$nextTick(() => {
        //   this.MultXList[this.subjectIndex].options = arr;
        //   this.MultXList[this.subjectIndex].steam = arrq;
        // });
        this.multxIndexChange(this.subjectIndex);
      } else if (
        this.subjectType === "JudgX" &&
        this.subjectIndex < this.JudgXList.length - 1
      ) {
        this.subjectIndex = this.subjectIndex + 1;
        // let arr = this.JudgXList[this.subjectIndex].steam;
        // this.JudgXList[this.subjectIndex].steam = [];
        // this.$nextTick(() => {
        //   this.JudgXList[this.subjectIndex].steam = arr;
        // });
        this.judgexIndexChange(this.subjectIndex);
      } else if (
        this.subjectType === "FillX" &&
        this.subjectIndex < this.FillXList.length - 1
      ) {
        this.subjectIndex = this.subjectIndex + 1;
        this.fillxChange(this.subjectIndex);
      } else if (
        this.subjectType === "ProofX" &&
        this.subjectIndex < this.ProofXList.length - 1
      ) {
        this.subjectIndex = this.subjectIndex + 1;
        this.proofxChange(this.subjectIndex);
      } else if (
        this.subjectType === "AnwsX" &&
        this.subjectIndex < this.AnwsXList.length - 1
      ) {
        this.subjectIndex = this.subjectIndex + 1;
        this.anwsxChange(this.subjectIndex);
      }
      if (this.subjectType === "MultX") {
        this.multipleTemp = this.MultXList[this.subjectIndex].answers;
      }
    },

    MultXListChange(value) {
      console.log(value);

      this.resultList.map(val => {
        val.questionId === value.qid
          ? (val.result = value.correctOrder.join(","))
          : val.result;
        console.log(val.result);
      });
      console.log(this.resultList);
    },

    //退出
    secedeFunc() {
      this.$router.go(-1);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）

  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {
    clearInterval(this.interval);
  }, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
.page {
  display: flex;
  font-size: 14px;
  .left {
    position: relative;
    width: 242px;
    .btnBox {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 40px;
      width: 100%;
      display: flex;
      justify-content: space-around;
    }
    .item {
      display: flex;
      padding: 20px 30px;
      // background: #f8fafb;
      cursor: pointer;
      img {
        width: 20px;
        margin-right: 15px;
        height: 20px;
      }
    }
  }
  .center {
    background: #f8fafb;
    width: 223px;
    height: 100%;
    overflow: auto;
    .wrap {
      display: flex;
      padding: 10px 0;
      //justify-content: space-around;
      align-items: center;
      cursor: pointer;
    }
    .item {
      white-space: nowrap;
      margin: 0 15px;
    }
    .blue {
      color: #006dfe;
    }
  }
  .right {
    flex-grow: 1;
    // padding: 28px;
    padding-top: 0;
    background: #f8fafb;
    text-align: left;
    width: 1075px;
    position: relative;
    .item {
      height: 100%;
      width: 100%;
      font-size: 14px;
      background: #fff;
      justify-content: left;
      padding: 26px 20px;
      // margin-top: 15px;
      margin-top: 0;
      .title {
        font-size: 20px;
        margin-bottom: 20px;
      }
      img {
        // 有图片题目的保持和文字居中对齐
        vertical-align: middle;
      }
    }
  }
  .el_radio_group {
    //display: flex;
    font-size: 26px;
    flex-wrap: wrap;
    overflow-x: auto;
    .el_radio {
      position: relative;
      // width: 45%;
      padding: 15px;
      // border-bottom: solid 1px #eee;
      display: flex;
      align-items: center;
    }
  }
}
.bottom {
  position: absolute;
  bottom: 0;
  width: 1015px;
  margin: 0 auto;
  background: #fff;
  height: 40px;
  display: flex;
  line-height: 40px;
  justify-content: center;
  .last,
  .next {
    margin: 0 100px;
    cursor: pointer;
  }
}
::v-deep .groupbox .el-radio .el-radio__input {
  width: 40px;
  height: 40px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}
::v-deep .el-radio .el-radio__input:hover {
  border-color: #409eff;
}
::v-deep .el_radio_group .el-radio__label {
  font-size: 20px;
}
::v-deep .el-radio__inner {
  border: 0;
  width: 0;
  height: 0;
}
::v-deep .el-checkbox .el-checkbox__input {
  width: 40px;
  height: 40px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}
::v-deep .el-checkbox .el-checkbox__input:hover {
  border-color: #409eff;
}
::v-deep .el-checkbox .el-checkbox__inner {
  border: 0;
  width: 0;
  height: 0;
}
::v-deep .el-checkbox__label {
  font-size: 20px;
  width: 80%;
}

.box {
  font-size: 40px;
}
.labelbox {
  margin-left: -40px;
}
.labelbox1 {
  margin-left: 10px;
}
::v-deep .el-icon-circle-close:hover {
  color: #409eff;
}
::v-deep .el-icon-circle-check:hover {
  color: #409eff;
}
.active {
  background-color: #f8fafb;
}
.tipsBox {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}
::v-deep .katex {
  font-size: 30px;
}
.color {
  background: red;
}
.success {
  background: greenyellow;
}
</style>
